import { CommonWrapper } from '@kanda-libs/ks-component-ts';
import {
  ConfigWrapper,
  type HomeLinkProps,
} from '@kanda-libs/ks-design-library';
import HelpModal from 'components/layout/Main/components/HelpModal';
import { URLS } from 'config';
import { FunctionComponent, JSX } from 'react';
import { Link } from 'react-router-dom';

export interface AppWrapperProps {
  children: JSX.Element;
}

const AppWrapper: FunctionComponent<AppWrapperProps> = function ({ children }) {
  return (
    <ConfigWrapper
      linkComponent={Link as FunctionComponent<HomeLinkProps>}
      homeLinkProps={{
        to: URLS.home,
      }}
    >
      <CommonWrapper>
        {children}
        <HelpModal />
      </CommonWrapper>
    </ConfigWrapper>
  );
};

export default AppWrapper;
